import React from 'react';
import { MarisaAutoContract, MarisaAutoDetails } from '~/scenes';
import { Stack } from '../stackNavigation';

export const InsuranceAutoNavigation = (
  <Stack.Group>
    <Stack.Screen
      name="MarisaServicos_MarisaAutoContract"
      component={MarisaAutoContract}
    />

    <Stack.Screen
      name="MarisaServicos_MarisaAutoDetails"
      component={MarisaAutoDetails}
    />
  </Stack.Group>
);
